import EventEmitter from "events";
import {
  RPCRequest,
  RPCResponse,
  RPCResponses
} from "src/modules/communication-protobuf";
import { v4 as uuid4 } from "uuid";

const CALL_TIMEOUT = 5000;
const TIMEOUT_ERROR = "RPC_CALL_TIMED_OUT";

export default class RPC extends EventEmitter {
  constructor({ messenger, peerJid }) {
    super();
    this.messenger = messenger;
    this.peerJid = peerJid;
    this.onRequest = this.onRequest.bind(this);
    this.onResponse = this.onResponse.bind(this);
    this.initialize();
    this.requests = {};
  }

  initialize() {
    this.messenger.on("rpcRequest", this.onRequest);
    this.messenger.on("rpcResponse", this.onResponse);
  }

  destroy() {
    this.messenger.removeListener("rpcRequest", this.onRequest);
    this.messenger.removeListener("rpcResponse", this.onResponse);
    Object.values(this.requests).forEach((request) => {
      clearTimeout(request.timeoutId);
    });
  }

  async call(request, sendTo, options) {
    const uuid = uuid4();
    const { name, payload } = request;
    const rpcRequest = RPCRequest.create({ [name]: payload, uuid });

    return new Promise((resolve, reject) => {
      this.messenger.sendAsEnvelope({
        payload: { rpcRequest },
        to: sendTo,
        sendBy: options?.sendBy || request.sendBy
      });

      const timeoutId = setTimeout(() => {
        reject(TIMEOUT_ERROR);
        delete this.requests[uuid];
      }, options?.timeout || CALL_TIMEOUT);

      this.requests[uuid] = { timeoutId, resolve, reject, rpcRequest };
    });
  }

  onRequest({ uuid, ...requestWrapper }, from) {
    if (this.peerJid && this.peerJid !== from) return;
    const requestName = Object.keys(requestWrapper)[0];

    const sendResponse = (response, sendBy) => {
      if (response == null) {
        response = RPCResponses.Empty.create();
      }
      const { name, payload } = response;

      const rpcResponse = RPCResponse.create({ uuid, [name]: payload });
      this.messenger.sendAsEnvelope({
        payload: { rpcResponse },
        to: from,
        sendBy: sendBy || response.sendBy
      });
    };

    this.emit(requestName, requestWrapper[requestName], from, sendResponse);
  }

  onResponse({ uuid, ...responseWrapper }) {
    const request = this.requests[uuid];
    if (request == null) {
      return;
    }
    clearTimeout(request.timeoutId);
    const responseName = Object.keys(responseWrapper)[0];
    request.resolve(responseWrapper[responseName]);
  }
}
